import React from 'react';

import { RestrictionsButtonPlaceholder } from './RestrictionsButtonPlaceholder';

export const RestrictionsButtonLoading = () => {
	return <RestrictionsButtonPlaceholder />;
};
